const selectors = {
  selectSaleItem: 'Select Sales Order{{mode}}',
  multiple: ' (Multiple)',
  single: ' (Single)',
};

export default selectors;